export default () => useRuntimeConfig().public.env as string
